// removed by extract-text-webpack-plugin
module.exports = {"BreakpointToSmall":"(max-width: 374px)","container":"G7a2b17"};